const DataSubMenu = ({subNavOptions, setActiveTab, activeTab }) => {
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <ul className="data-submenu tif-mb-0">
            {subNavOptions.map((option) => (
                <li key={option} className={activeTab === option ? 'active' : ''} onClick={() => handleTabClick(option)}>
                    {option}
                </li>
            ))}
        </ul>
    );
};

export default DataSubMenu;